import React, {useState} from 'react';
import {Link, useSearchParams} from 'react-router-dom';
import {resetPassword} from '../../services/auth-service';
import MinimalLayout from "../../layouts/minimal";
import Alert from "../../components/alert";
import {ErrorMessage, Field, Form, Formik} from "formik";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {resetPasswordRequestSchema} from "../../utils/schemas";
import {useGlobalNotificationMessage} from "../../context/message";
import {AppRoutes} from "../../utils/constants";

export default function ResetPassword () {
  const [queryString] = useSearchParams();
  const login = queryString.get('login');
  const token = queryString.get('token');

  const [responseMessage, setResponseMessage] = useState({type: 'danger', message: null});
  const [submitted, setSubmitted] = useState(false);
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();

  const handleSubmit = (values, { setSubmitting, setErrors }) => {
    removeMessage();
    resetPassword({
      login: login,
      token: token,
      password: values.password,
      password_confirmation: values.password_confirmation
    }).then((responseData) => {
      setSubmitted(true);
    }).catch(error => {
      if( error.response ){
        HelperService.handleApiErrors(error, addErrorMessage, "Obnova hesla nebola úspešná.");
      }
      HelperService.handleFormErrors(error, setErrors);
    }).finally(()=>{setSubmitting(false);});
  };

  return (
    <>
      <Section animation={HelperService.getRandomAnimation()}>
        <div className="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xxl-4 col-lg-5">
                <div className="card">

                  <div className="card-header pt-4 pb-4 text-center bg-primary bg-pattern">
                    <Link to={AppRoutes.landing.path}>
                      <span><img src="/images/logo.png" alt="" height="50" /></span>
                    </Link>
                  </div>

                  {(!token || !login) && <div className="card-body p-4">
                    <div className={"my-2 p-2 text-center"}>
                      <span className="mdi mdi-help-circle-outline mb-2 text-danger" style={{'fontSize':'50px'}}></span><br />
                      <p>Pre obnovu hesla je potrebný token a login, ktorý nevieme nájsť. Prosím skontrolujte, či ste zadali celú adresu, ako vám bola doručená na email.</p>
                      <p className="mb-2 text-center">
                        <Link to={AppRoutes.login.path} className={"btn btn-outline-secondary"}>Prihlásenie</Link>
                      </p>
                    </div>
                  </div>}

                  {submitted && token && login && <div className="card-body p-4">
                    <div className={"my-2 p-2 text-center"}>
                      <span className="mdi mdi-check-circle-outline mb-2 text-success" style={{'fontSize':'50px'}}></span><br />
                      <p>Vaše heslo bolo zmenené. Teraz sa môžete prihlásiť.</p>
                      <p className="mb-2 text-center">
                        <Link to={AppRoutes.login.path} className={"btn btn-outline-primary"}>Prihlásenie</Link>
                      </p>
                    </div>
                  </div>}

                  {!submitted && token && login && <div className="card-body p-4">

                    <div className="text-center w-75 m-auto">
                      <h4 className="text-dark-50 text-center pb-0 fw-bold">Zmena hesla</h4>
                      <p className="text-muted mb-4">Zadajte svoje nové heslo.</p>
                    </div>

                    <Alert type={responseMessage.type} className={"my-2"}>{responseMessage.message}</Alert>

                    <Formik
                      initialValues={resetPasswordRequestSchema.cast()}
                      validationSchema={resetPasswordRequestSchema}
                      onSubmit={handleSubmit}
                    >
                      {({ isSubmitting, errors, touched }) => (
                        <Form>

                          <div className="mb-3">
                            <label htmlFor="password" className="form-label">Nové heslo</label>
                            <Field type="password" required
                                   name="password"
                                   placeholder="Nové heslo"
                                   className={`form-control ${errors.password && touched.password ? "is-invalid":""}`} />
                            <ErrorMessage name="password" component="div" className="invalid-feedback" />
                          </div>

                          <div className="mb-3">
                            <label htmlFor="password_confirmation" className="form-label">Zopakujte heslo</label>
                            <Field type="password" required
                                   name="password_confirmation"
                                   placeholder="Znovu zadajte heslo"
                                   className={`form-control ${errors.password_confirmation && touched.password_confirmation ? "is-invalid":""}`} />
                            <ErrorMessage name="password_confirmation" component="div" className="invalid-feedback" />
                          </div>

                          <div className={"text-center"}>
                            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>Odoslať</button>
                          </div>
                        </Form>
                      )}
                    </Formik>

                    {submitted && <div className={"my-5 p-5 text-center"}>
                      <span className="mdi mdi-check-decagram-outline mb-2 text-success" style={{'font-size':'25px'}}></span><br />
                      <p>Vaše heslo bolo zmenené. Teraz sa môžete prihlásiť.</p>
                    </div>}

                    <hr className={"mt-4 d-block"} />

                    <p className="mb-4 text-center">
                      <Link to={AppRoutes.login.path} className={"link-secondary"}>Prihlásenie</Link>
                    </p>

                  </div>}

                </div>

              </div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}

ResetPassword.getLayout = function getLayout(page) {
  return (
    <MinimalLayout>
      {page}
    </MinimalLayout>
  )
}

ResetPassword.getSEO = function getSEO() {
  return {
    title: "Zmena hesla",
  }
}
